import { gql, useMutation } from '@apollo/client';

export const TOGGLE_MATCH_OFFER_MUTATION = gql`
    mutation ($offerGuid: String!, $isSelected: Boolean!){
        toggleOfferSelection(offerGuid: $offerGuid, isSelected: $isSelected){
            bhpnDecisionDate
            comments
            declinedDate
            declinedParty
            declinedReason
            directCareHours
            firstServiceDate
            groupCareHours
            guid
            highLevelSupervisionHours
            id
            lastServiceDate
            midLevelSupervisionHours
            offerHourPercentage
            otherClinicLocation
            provideAllEstimatedHours
            provideServiceInRequiredLanguage
            provideServicesInClinic
            status
            submittedAt
        }
    }
`;

export const useToggleMatchOffer = () => {
    const [
        execute,
        {
            error,
            loading
        }
    ] = useMutation(TOGGLE_MATCH_OFFER_MUTATION);


    return {
        execute,
        error,
        loading
    };
};
